import { FC } from 'react'
import Skeleton from '@components/skeleton'
import {
    CellContent,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
    TableSection,
} from './skeletonTable.styles'
import { SkeletonTableProps } from './SkeletonTable.types'

const SkeletonTable: FC<SkeletonTableProps> = ({
    columnCount,
    rowCount,
    testIdPrefix,
}) => {
    const columns = Array.from({ length: columnCount })
    const rows = Array.from({ length: rowCount })

    return (
        <Skeleton>
            <TableSection>
                <TableHeader data-testid={`${testIdPrefix}-header`}>
                    {columns.map((_, index) => (
                        <TableHeaderCell
                            key={index}
                            data-testid={`${testIdPrefix}-header-cell`}
                        />
                    ))}
                </TableHeader>
                {rows.map((_, rowIndex) => (
                    <TableRow
                        key={rowIndex}
                        data-testid={`${testIdPrefix}-row`}
                    >
                        {columns.map((__, cellIndex) => (
                            <TableCell
                                key={cellIndex}
                                data-testid={`${testIdPrefix}-cell`}
                            >
                                <CellContent />
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableSection>
        </Skeleton>
    )
}

export default SkeletonTable
